<template>
  <Field
    class="LaptopSubtitle"
    :placeholder="$t('subtitle')"
    :value="articleLaptop.subtitle"
    @update:value="$up('subtitle', $event)">
    <FieldBtn @click="generateSubtitle">
      {{ $t('generate') }}
    </FieldBtn>
  </Field>
</template>

<script>
import generateLaptopSubtitle from './generateLaptopSubtitle'

export default {
  props: {
    articleLaptop: { type: Object, required: true },
    laptop: { type: Object, required: true },
    topic: { type: String, required: true },
  },
  methods: {
    generateSubtitle() {
      const subtitle = generateLaptopSubtitle(
        this.laptop,
        this.topic,
        this.articleLaptop.subtitle,
      )

      this.$up('subtitle', subtitle)
    },
  },
}
</script>

<style lang="scss">
.LaptopSubtitle {
  display: flex;
  flex-grow: 1;
  margin: 0 $uh;

  > .Field {
    flex-grow: 1;
  }
}
</style>

<i18n>
{
  "en": {
    "generate": "Generate",
    "subtitle": "Subtitle"
  }
}
</i18n>
